import { useState } from 'react'
import { AppBar, IconButton, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import { SearchIcon } from '$common/icons'
import { CloseIcon } from '$common/icons/close'
import { BackButton } from '$common/buttons'
import { t } from '$setup/internationalization'
import { PageToolbar } from '$common/app-bar/common/page-toolbar'
import { AppBarSearchInput } from '$common/input/app-bar-search-input'

const TitleTypography = styled(Typography)`
  margin-right: 7px;
  flex-grow: 1;
`

interface Prop {
  title: string
  onBack: () => any
  setQuery: (query: string) => void
  onSearch?: () => void
  searchMode: boolean
}

export function AppBarBackTitleSearch({
  title,
  onBack,
  setQuery,
  onSearch,
  searchMode,
}: Prop) {
  const [searchQuery, setSearchQuery] = useState('')

  return (
    <AppBar position="static">
      <PageToolbar>
        <BackButton onClick={onBack} />

        {searchMode ? (
          <AppBarSearchInput
            autoFocus
            fullWidth
            value={searchQuery}
            placeholder={t('common.search')}
            onChange={e => {
              setQuery(e.target.value)
              setSearchQuery(e.target.value)
            }}
          />
        ) : (
          <TitleTypography color="neutral900" variant="subtitle1">
            {title}
          </TitleTypography>
        )}

        <IconButton
          onClick={() => {
            if (searchMode) {
              setQuery('')
              setSearchQuery('')
            } else onSearch?.()
          }}
        >
          {searchMode ? (
            <CloseIcon sx={{ color: 'neutral900' }} />
          ) : (
            <SearchIcon sx={{ color: 'neutral900' }} />
          )}
        </IconButton>
      </PageToolbar>
    </AppBar>
  )
}
